import { ReactNode, useContext } from "react";
import { DARK_THEME, LIGHT_THEME } from "../../../../styles/const.theme";
import ReactiveToggle from "../../ReactiveToggle";
import { ThemeContext } from "../../../../context/context.theme";

const ThemeController = ({
  children,
}: {
  children: (
    changeTheme: () => void,
    currentTheme: string,
    isPending: boolean,
  ) => ReactNode;
}) => {
  const { theme, changeTheme } = useContext(ThemeContext);

  return (
    <ReactiveToggle
      transitional={() => {
        if (theme === LIGHT_THEME) {
          changeTheme(DARK_THEME);
          return;
        }
        changeTheme(LIGHT_THEME);
      }}
    >
      {(handleClick, isPending) => children(handleClick, theme, isPending)}
    </ReactiveToggle>
  );
};
export default ThemeController;
